import React, { useContext } from "react";
import { apiPut } from "../../utils/apiFetch";
import apiPath from "utils/apiPath";
import useToastContext from "hooks/useToastContext";
import { AiFillEye } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import AuthContext from "context/AuthContext";
import { isEmpty } from "lodash";
import helpers from "../../utils/helpers";
import OTableHead from "components/reusable/OTableHead";
import { useNavigate } from "react-router-dom";
import { motion } from 'framer-motion';
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";

const DriverTable = ({ country, allSubAdmin, page, sort, setSort, manager }) => {
  const { t } = useTranslation();
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const notification = useToastContext();

  const handelStatusChange = async (item) => {
    try {
      const payload = {
        status: item?.status === "inactive" ? "active" : "inactive",
      };
      const path = `${apiPath.getDriverList}/status-change/${item?._id}`;
      const result = await apiPut(path, payload);
      if (result?.data?.success) {
        notification.success(result.data.message);
        allSubAdmin("listing");
        return
      }
      notification.error(result.data.message);
    } catch (error) {
      console.error("error in get all sub admin list==>>>>", error.message);
    }
  };


  const handelDeleteDriver = async (item) => {
    try {
      const path = `${apiPath.getDriverList}/delete/${item?._id}`;
      const resp = await apiPut(path);
      if (resp?.data?.success) {
        notification.success(resp.data.message);
        allSubAdmin("listing");
        return
      }
      notification.error(resp.data.message);
    } catch (error) {
      console.error("error in get all sub admin list==>>>>", error.message);
    }
  };


  const rowVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.1,
      },
    }),
  };

  return (
    <div className="p-3">
      <div className="overflow-x-auto rounded-lg border relative">
        <table className="dark:text-gray-400 w-full text-xs text-left text-[#A5A5A5]">
          <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" className="py-3 px-3 text-center">
                {t("S.NO")}
              </th>
              <OTableHead sort={sort} name={"NAME"} fieldName={"fullName"} setSort={setSort} />
              <OTableHead sort={sort} name={"ROLE_AND_SERVICES"} fieldName={"role"} setSort={setSort} />
              <OTableHead sort={sort} name={"O_CONTACT"} setSort={setSort} />
              <OTableHead sort={sort} name={"O_PERFORMANCE"} setSort={setSort} />
              <OTableHead sort={sort} name={"AVAILABILITY"} setSort={setSort} />
              <OTableHead sort={sort} name={"O_CREATED_AT"} fieldName={"createdAt"} setSort={setSort} />
              <th scope="col" className="text-left py-3 px-3 ">
                {t("O_STATUS")}
              </th>
              <th scope="col" className="py-3 px-3 text-center">
                {t("O_ACTION")}
              </th>
            </tr>
          </thead>
          <tbody>
            {country?.map((staff, i) => {
              return (<motion.tr
                key={staff.id}
                custom={i}
                initial="hidden"
                animate="visible"
                variants={rowVariants}
                className={`bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 transition ${helpers.ternaryCondition(staff?.isDeleted, 'text-red-500 bg-[#f2f2f2]')}`}
              >
                <th scope="row" className="py-2 px-3 border-r text-center font-medium text-gray-900  dark:text-white">
                  {i + 1 + 10 * (page - 1)}
                </th>
                <td className="py-2 px-3 whitespace-nowrap border-r">
                  <div className={`font-medium ${helpers.ternaryCondition(staff?.isDeleted, 'text-red-500', 'text-gray-900 dark:text-gray-300')}`}>{helpers.capitalizeFirstWord(staff?.fullName)}</div>
                  {/* <div
                    className={`text-xs font-semibold ${helpers.ternaryCondition(staff?.isOnline, 'text-green-500', 'text-red-500')}`}
                  >
                    {staff.isDeleted ===true ?" ":helpers.ternaryCondition(staff?.isOnline, 'Online', 'Offline')}
                  </div> */}
                </td>

                <td className="py-2 px-3 whitespace-nowrap border-r">
                  <div>{helpers.capitalizeFirstWord(staff?.role)}</div>

                  {!staff?.isDeleted && (
                    <div className="flex gap-2 mt-1 flex-wrap">
                      {staff?.serviceOffered?.map((service) => (
                        <span
                          key={service?._id}
                          className="bg-gray-200 text-gray-700 text-xs px-2 py-0.5 rounded-full">
                          {helpers.capitalizeFirstWord(service?.name)}
                        </span>
                      ))}
                    </div>
                  )}
               
                </td>
                <td className="py-2 px-3  border-r text-left">
                  <div>{staff?.email || 'N/A'}</div>
                 {helpers.andOperator(!staff?.isDeleted, <div className="text-xs text-gray-500"> +{staff?.countryCode}-{staff?.mobile}</div>)}
                </td>
                <td className="py-2 px-3 border-r">
                  <div>
                    <span className="text-xs text-gray-400">Tasks: </span>
                    <strong>{helpers.orOperator(staff?.totalTasks, 0)}</strong>
                  </div>
                  <div>
                    <span className="text-xs text-gray-400">Response Time: </span>
                    <strong>{staff?.avgResponseTime?.toFixed(2) || 0} Min</strong>
                  </div>
                  <div>
                    <span className="text-xs text-gray-400">Rating: </span>{" "}
                    <strong>{helpers.orOperator(staff?.rating?.toFixed(2), 0)} ★</strong>
                  </div>
                </td>
                <td
                  className={`py-2 px-3 whitespace-nowrap text-xs border-r ${helpers.getTextColor(staff?.availabilityStatus)} ${staff?.status === "active" ? '' : 'text-gray-500'
                    }`}
                >
                  {staff?.status === "active"
                    ? helpers.capitalizeFirstWord(staff?.availabilityStatus)
                    : <span className="text-gray-500">N/A</span>}
                </td>


                <td className="py-2 px-3 whitespace-nowrap gap-2 border-r">
                  {helpers.getDateAndTime(staff?.createdAt)}
                </td>
                <td className="py-2 px-3 whitespace-nowrap border-r">
                  {staff?.isDeleted === true ? (
                    <span className="text-red-500 font-semibold">Deleted</span>
                  ) : (
                    <label
                      className={`items-center cursor-pointer inline-flex relative ${helpers.ternaryCondition(!isEmpty(manager), !manager?.add, !user?.permission?.length == 0) ? "opacity-50 cursor-not-allowed" : ""}`}
                      title={`${staff?.status === "active" ? "Active" : "Inactive"}`}
                    >
                      <input
                        className="sr-only peer"
                        disabled={helpers.ternaryCondition(!isEmpty(manager), !manager?.add, !user?.permission?.length == 0)}
                        checked={staff?.status === "active"}
                        onChange={(e) => helpers.alertFunction(`Are you sure you want to ${e.target.checked ? "active" : "inactive"} "${staff?.fullName}"?`, staff, handelStatusChange)}
                        type="checkbox"
                      />
                      <div
                        className={`peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 w-10 h-5 bg-gray-200 rounded-full dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-gradientTo ${helpers.ternaryCondition(!isEmpty(manager), !manager?.add, !user?.permission?.length == 0) ? "bg-gray-300 dark:bg-gray-600" : ""
                          }`}
                      />
                    </label>
                  )}
                </td>
                <td className="py-4 px-3 whitespace-nowrap  gap-2 border-r">
                 
                    <ul className="flex justify-center items-center">
                      {helpers.ternaryCondition(!staff?.isDeleted,
                        <>
                          <li
                            onClick={() => {
                              navigate("/driver-manager/edit", {
                                state: staff,
                              });
                            }}
                            className="px-2 py-2 hover:bg-white hover:text-LightBlue dark:hover:bg-transparent"
                            title={'Edit'}
                          >
                            <FaEdit className="cursor-pointer w-5 h-5 text-slate-600" />
                          </li>

                          <li
                            onClick={(e) => helpers.alertFunction(`Are you sure you want to delete "${staff?.fullName}"?`, staff, handelDeleteDriver)}
                            className="px-2 py-2 hover:bg-white hover:text-LightBlue dark:hover:bg-transparent"
                            title={'Delete'}
                          >
                            <MdDelete className="cursor-pointer text-red-500" size={23} />
                          </li>


                          <li
                            onClick={() => {
                              navigate("/driver-manager/view", {
                                state: staff,
                              });
                            }}
                            className="px-2 py-2 hover:bg-white hover:text-LightBlue dark:hover:bg-transparent"
                            title={'View'}
                          >
                            <AiFillEye className="cursor-pointer text-slate-600" size={23} />
                          </li>
                        </>,<li   className="px-2 py-2 mt-2 hover:bg-white hover:text-LightBlue dark:hover:bg-transparent">N/A</li>)}
                     
                    </ul>
                

                </td>
              </motion.tr>)
            })}



            {isEmpty(country) ? (
              <tr className="bg-white border-b w-full text-center dark:bg-gray-800 dark:border-gray-700">
                <td className="py-4 px-6" colSpan={12}>
                  {t("O_NO_RECORD_FOUND")}
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DriverTable;
